export default __webpack_public_path__ + "static/media/Blesswar Bracers.1f573625.jpg";